import { render, staticRenderFns } from "./AINoElementSelected.vue?vue&type=template&id=01476e99&"
import script from "./AINoElementSelected.vue?vue&type=script&lang=ts&"
export * from "./AINoElementSelected.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports